import { Directive, TemplateRef, inject, input } from '@angular/core';

import { MultiSelectOptionViewModel, MultiSelectOptionWithSelectedViewModel } from '../multi-select.view-model';

export interface MultiSelectCustomOptionContext<TValue, TData> {
  $implicit: MultiSelectOptionWithSelectedViewModel<TValue, TData>;
}

@Directive({
  selector: '[appMultiSelectCustomOption]',
  standalone: true,
})
export class MultiSelectCustomOptionDirective<TValue, TData = unknown> {
  public readonly templateRef = inject(TemplateRef);
  public readonly appMultiSelectCustomOptionOptions = input.required<MultiSelectOptionViewModel<TValue, TData>[]>();

  public static ngTemplateContextGuard<TValue, TData>(
    _: MultiSelectCustomOptionDirective<TValue, TData>,
    _context: unknown
  ): _context is MultiSelectCustomOptionContext<TValue, TData> {
    return true;
  }
}
